import React, { useState } from 'react';
import Cookies from 'js-cookie';
import { useNavigate } from 'react-router-dom';
import { BASE_URL } from '../config/constants';
function Profile() {
	const [loginCheck, setLoginCheck] = useState(false);
	const navigate = useNavigate();

	const handleLogout = () => {
		const token = Cookies.get('token');
		if (token) {
			setLoginCheck(true);
		}

		const userConfirmed = window.confirm('Are you sure you want to log out?');
		if (userConfirmed) {
			setLoginCheck(false);
			Cookies.remove('token');
			navigate('/login');
		}
	};

	const userData = JSON.parse(window.localStorage.getItem('userData'));

	const [editData, setEditData] = useState({
		firstName: userData.firstName,
		lastName: userData.lastName,
		password: null,
		oldPassword: null,
	});

	const [confirmPassword, setConfirmPassword] = useState(null);
	const [message, setMessage] = useState('');
	const [isLoading, setIsLoading] = useState(false);

	// دالة للتحقق من قوة كلمة المرور
	const validatePassword = (password) => {
		const minLength = 8;
		const hasUpperCase = /[A-Z]/.test(password);
		const hasLowerCase = /[a-z]/.test(password);
		const hasDigits = /\d/.test(password);
		const hasSpecialChars = /[!@#$%^&*(),.?":{}|<>]/.test(password);

		if (password.length < minLength) {
			return 'Password must be at least 8 characters long.';
		}
		if (!hasUpperCase) {
			return 'Password must contain at least one uppercase letter.';
		}
		if (!hasLowerCase) {
			return 'Password must contain at least one lowercase letter.';
		}
		if (!hasDigits) {
			return 'Password must contain at least one number.';
		}
		if (!hasSpecialChars) {
			return 'Password must contain at least one special character.';
		}

		return null;
	};

	const validateInput = () => {
		if (!editData.firstName || !editData.lastName) {
			setMessage('First Name and Last Name cannot be empty.');
			return false;
		}
		if (editData.password && editData.password !== confirmPassword) {
			setMessage('Passwords do not match.');
			return false;
		}
		if (editData.password) {
			const passwordValidationMessage = validatePassword(editData.password);
			if (passwordValidationMessage) {
				setMessage(passwordValidationMessage);
				return false;
			}
		}
		return true;
	};

	const handleEdit = async (e) => {
		e.preventDefault();
		setIsLoading(true);

		// Validate input
		if (!validateInput()) {
			setIsLoading(false);
			return;
		}

		if (
			editData.firstName === userData.firstName &&
			editData.lastName === userData.lastName &&
			!editData.password &&
			!editData.oldPassword
		) {
			setMessage('No changes were made.');
			setIsLoading(false);
			return;
		}

		try {
			const token = Cookies.get('token');
			if (!token) {
				throw new Error('Token not found');
			}

			const payload = {
				firstName: editData.firstName,
				lastName: editData.lastName,
				password: editData.password || null,
				oldPassword: editData.oldPassword || null,
			};
			const baseUrl = BASE_URL;
			const response = await fetch(`${baseUrl}/api/v1/auth/me`, {
				method: 'PATCH',
				body: JSON.stringify(payload),
				headers: {
					Authorization: `Bearer ${token}`,
					'Content-Type': 'application/json',
				},
			});

			const data = await response.json();
			if (response.ok) {
				window.localStorage.setItem('userData', JSON.stringify(data));
				setEditData({
					firstName: data.firstName,
					lastName: data.lastName,
					password: null,
					oldPassword: null,
				});
				setConfirmPassword(null);
				setMessage('User data updated successfully.');
			} else {
				setMessage('Failed to update data.');
			}
		} catch (error) {
			setMessage('Something went wrong.');
			console.error(error);
		} finally {
			setIsLoading(false);
		}
	};

	return (
		<div className='my-10 mt-36'>
			<div className='container grid grid-cols-1 md:grid-cols-4 gap-6 md:gap-0'>
				<aside className='p-4 md:border-solid md:border-[1px] md:border-[#d1d7dc]'>
					<div className='user-data flex flex-col items-center gap-2 justify-center'>
						<div className='image w-32 h-32 rounded-full flex justify-center items-center font-bold text-2xl text-main bg-secondary'>
							{`${userData.firstName
								.slice(0, 1)
								.toUpperCase()}${userData.lastName.slice(0, 1).toUpperCase()}`}
						</div>
						<p className='name text-main text-lg font-bold text-center'>{`${userData.firstName} ${userData.lastName}`}</p>
						<button
							className='bg-red-700 px-5 py-2 rounded text-white'
							onClick={handleLogout}>
							Log Out
						</button>
					</div>
				</aside>

				<section className='border-solid border-[1px] border-[#d1d7dc] md:col-span-3'>
					<div className='headerOfProfileData flex flex-col gap-2 p-4 items-center justify-center border-solid border-b-[1px] border-[#d1d7dc]'>
						<h2 className='text-main text-lg font-semibold'>Profile Data</h2>
						<p className='text-main'>Add information about yourself</p>
					</div>
					<div className='inputsDataEditing flex flex-col justify-center gap-3 p-4 md:px-28'>
						<p className='text-main'>Your Data:</p>
						<div className='firstName'>
							<input
								type='text'
								value={editData.firstName}
								className='profile-input-edit'
								onChange={(e) =>
									setEditData({ ...editData, firstName: e.target.value })
								}
							/>
						</div>
						<div className='lastName'>
							<input
								type='text'
								value={editData.lastName}
								className='profile-input-edit'
								onChange={(e) =>
									setEditData({ ...editData, lastName: e.target.value })
								}
							/>
						</div>

						<p className='text-main'>Password:</p>
						<div className='password'>
							<input
								type='password'
								className='profile-input-edit'
								onChange={(e) =>
									setEditData({ ...editData, oldPassword: e.target.value })
								}
								placeholder='Enter Current Password'
							/>
						</div>
						<div className='newPassword'>
							<input
								type='password'
								className='profile-input-edit'
								onChange={(e) =>
									setEditData({ ...editData, password: e.target.value })
								}
								placeholder='Enter New Password'
							/>
						</div>
						<div className='reTypeNewPassword'>
							<input
								type='password'
								className='profile-input-edit'
								onChange={(e) => setConfirmPassword(e.target.value)}
								placeholder='Re-type New Password'
							/>
						</div>

						<button
							className={`text-main w-fit px-6 py-2 justify-start text-lg font-semibold ${
								isLoading ? 'bg-gray-400' : 'bg-secondary'
							}`}
							onClick={handleEdit}>
							{isLoading ? 'Saving...' : 'Save'}
						</button>

						{message && (
							<p
								className={`text-sm ${
									message.includes('successfully')
										? 'text-green-600'
										: 'text-red-700'
								}`}>
								{message}
							</p>
						)}
					</div>
				</section>
			</div>
		</div>
	);
}

export default Profile;
